@if (_currentData.resouceDef) {
  <div class="main-content-container">
    <!-- <div class="container-title">
    <h3 *ngIf="_currentData.currentAction == 'LIST'" class="mb-0">
      {{baseService._currentTitle}}
    </h3>
    <h3 *ngIf="_currentData.currentAction != 'LIST'" class="mb-0">
      <div class="d-flex align-items-center">
        <div class="">
          {{baseService._currentTitle}}
        </div>
      </div>
    </h3>
  </div> -->
  <div class="main-container-body">
    @if (_currentData.currentData) {
      <dhs-form [action]="_currentData.currentAction" [fieldGroup]="_currentData.currentFormFields" [config]="_currentData.config" [data]="_currentData.currentData" [customButton]="_currentData.customButton" (saveFinished)="onSaveFinished($event)" (questionValueChanged)="onValueChanged($event)"></dhs-form>
    }
  </div>
</div>
}